import React, { useEffect, useState, useContext } from "react";
import AppContext from "../../../context/AppContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../../../assets/css/gcstudent/studentauthentication/StudentAuthPages.css";

const BookIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
    <path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const StudentForgotPasswordPage = () => {
  const navigate = useNavigate();
  const {baseUrl} = useContext(AppContext);
  const [cardIn,   setCardIn]   = useState(false);
  const [email,    setEmail]    = useState("");
  const [sent,     setSent]     = useState(false);
  const [error,    setError]    = useState("");
  const [loading,  setLoading]  = useState(false);

  useEffect(() => { setTimeout(() => setCardIn(true), 60); }, []);
  const handleSubmit = (e) => {
  e.preventDefault();
  setError("");

  if (!email) {
    setError("Please enter your email address.");
    return;
  }

  setLoading(true);

  axios.post(`${baseUrl}/student/auth/forgotPassword`, {
    email: email
  })
  .then((res) => {
    if (res.data.success) {
      setSent(true);
    } else {
      setError(
        res.data.message ||
        res.data.error ||
        "Something went wrong. Please try again."
      );
    }
  })
  .catch((err) => {
    console.error("FULL ERROR:", err);
    console.error("RESPONSE DATA:", err.response?.data);
    console.error("STATUS:", err.response?.status);

    setError(
      err.response?.data?.message ||
      err.response?.data?.error ||
      "Something went wrong. Please try again."
    );
  })
  .finally(() => {
    setLoading(false);
  });
  };


  return (
    <div className="gcStudent-auth-bg">
      <div className={`gcStudent-auth-card ${cardIn ? "gcStudent-auth-card--in" : ""}`}>

        {/* Logo */}
        <div className="gcStudent-auth-logo">
          <BookIcon />
        </div>

        {!sent ? (
          <>
            <h2 className="gcStudent-auth-title">Forgot Password?</h2>
            <p className="gcStudent-auth-sub">Enter your email to receive a reset link</p>

            {error && <div className="gcStudent-auth-error">{error}</div>}

            <form className="gcStudent-auth-form" onSubmit={handleSubmit} noValidate>
              <input
                className="gcStudent-auth-input"
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="email"
              />
              <button
                type="submit"
                className={`gcStudent-auth-btn ${loading ? "gcStudent-auth-btn--loading" : ""}`}
                disabled={loading}
              >
                {loading ? <span className="gcStudent-auth-spinner" /> : "Send Reset Link"}
              </button>
            </form>
          </>
        ) : (
          /* Success state */
          <div className="gcStudent-auth-success">
            <div className="gcStudent-auth-success-icon">
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="#0f8a65" strokeWidth="1.8"/>
                <path d="M8 12l3 3 5-5" stroke="#0f8a65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 className="gcStudent-auth-success-title">Email Sent!</h3>
            <p className="gcStudent-auth-success-msg">
              We've sent a password reset link to <strong>{email}</strong>. Please check your inbox.
            </p>
            <button
              className="gcStudent-auth-btn"
              onClick={() => navigate("/student/login")}
            >
              Back to Login
            </button>
          </div>
        )}

        <button className="gcStudent-auth-back" onClick={() => navigate("/")}>
          ← Back to Home
        </button>

      </div>
    </div>
  );
};

export default StudentForgotPasswordPage;